define(function(require) {
    return {
        ID : "SCENARIO_1",
        TYPE : "ThemeSet",
        TITLE : "Scénario 1",
        SELECTED_DATAVIEW_LAYER : "GEO07E12_POINTS_SPES",
        SELECTED_SEARCH_LAYER : "GEO07E12_POINTS_SPES",
        THEMESET_MAP_SETTINGS: {
            LAYERS_SETTINGS : [
                {LAYER_ID : "GEO07E12_POINTS_SPES", VISIBLE : true, LABEL_VISIBLE : false},
            ]
        },
        THEMESET_DATA_FILTER_SETTINGS : {
            FILTER_DATA_COLUMNS_SETTINGS : [
                {LAYER_ID : "DRAWING_LAYER", DATATABLE_ID : "AttributesDataTable_drawingLayer", DATACOLUMN_ID : "SCENARIO", DATA_FILTERS : [{TYPE: "StringFilter", FILTER_OPERATOR : "IS_EQUAL_TO", VALUE: "SCENARIO_1"}]}
            ]
        },
        THEMES : [
            {
                TYPE : "ThemeByIndividualValues",
                LEGEND_TEXT : "Scénario 1",
                REPRESENTATION_ENUM : "color",
                LAYER_ID : "GEO07E12_POINTS_SPES",
                DATATABLE_ID : "t_GEO07E12_POINTS_SPES",
                DATACOLUMN_ID : "THEME_SCENARIO_1",
                SCHEME : {
                    ID : "SCHEME_SCENARIO_1",
                    SCHEME_ELEMENTS : []
                }
            }
        ],
        DEFAULT : true
    };
});
